let DiccionarioCookiesAGuardar = 
[
    'usuariosexo',
    'usuarioemail',
    'usuarioanio',
    'usuarioDetalleClubNacion',
    'UsuarioDetalleGuid',
    'UsuarioDetalleNick',
    'UsuarioId',
    'UsuarioUsuario',
    'usuario%5Fusuario',
    'usuarioLogTkn',
    'cookieLogin',
    'syncLfLN',
    'tieneClub',
    'Provinciaid',
    'Paisid',
    'LNPreferencias',
    'Crm_id',
    'ProductoPremiumId',
    'token',
    'xvalue',
    'TokenJWT'
];

export const LeerCookie = (nombrecookie) => {
    return leer(nombrecookie);
}

export const CreateCookie = (name, value) => {
    let seconds = parseInt(window.config.Statics.CookieExpiration);
    var expires;
    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime() + (seconds));
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }

    if (document.domain === 'localhost') {
        document.cookie = name + "=" + value + expires + "; path=/";
    } else {
        document.cookie = name + "=" + value + expires + ";domain=" + window.config.Statics.DominioCookie + "; path=/";
    }
}

export const SetToken = (token) => {
    if (IsEmpty(token)) return;
    CreateCookie('token', token);
}

export const SetXValue = (xvalue) => {
    if (IsEmpty(xvalue)) return;
    CreateCookie('xvalue', xvalue);
}

export const IsEmpty = (obj) => {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}

export const SetupCookies = (obj) =>  {
    for (var key in obj) {
        var aux;
        var cookie;
        // Busco si la key se encuentra en el diccionario de cookies para ver si la grabo o no . 
        if (DiccionarioCookiesAGuardar.indexOf(key) > -1 && typeof obj[key] == "string") {
            switch (key) {
                case 'UsuarioDetalleGuid':
                    aux = "usuario%5Fdetalle%5Fguid";
                    cookie = '{' + leer("token") + '}';
                    break;
                case 'UsuarioDetalleNick':
                    aux = "usuario%5Fdetalle%5Fnick";
                    cookie = obj[key];
                    break;
                case 'UsuarioId':
                    aux = "usuario%5Fid";
                    cookie = obj[key];
                    break;
                case 'UsuarioUsuario':
                    aux = "usuario%5Fusuario";
                    cookie = obj[key];
                    break;
                case 'usuarioLogTkn':
                    aux = "usuario%5Flogtkn";
                    cookie = obj[key];
                    break;
                case 'TokenJWT':
                    aux = "PersoTKN";
                    cookie = obj[key];
                    break;
                default:
                    aux = key;
                    cookie = obj[key];
            }

            CreateCookie(aux, cookie);
        }
    }
}

function leer(nombrecookie) {
    var laCookie = '' + document.cookie;
    var indice = laCookie.indexOf(nombrecookie);

    if (indice == -1 || nombrecookie == '') {
        return '';
    }

    var indiceUno = laCookie.indexOf(';', indice);
    var indiceDos = laCookie.indexOf('&', indice);

    if (((indiceUno > indiceDos) && (indiceDos != -1)) || ((indiceUno == -1) && (indiceDos != -1))) {
        indiceUno = indiceDos;
    }

    if (indiceUno == -1) {
        indiceUno = laCookie.length;
    }

    return unescape(laCookie.substring(indice + nombrecookie.length + 1, indiceUno));
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/cookie.js